var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: {
          content:
            "Inventarios o pruebas que utilizan la tipología y fue administrado al evaluado:",
          "has-line": ""
        }
      }),
      _c("div", { staticClass: "px-3 mb-3" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.items, function(item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "my-3 d-flex align-items-center",
                class: {
                  "col-md-4": !_vm.isOther(item),
                  "col-md": _vm.isOther(item)
                }
              },
              [
                _c(
                  "div",
                  [
                    _c("check-box", {
                      staticClass: "mr-2 checkbox",
                      attrs: {
                        disabled: "",
                        text: item.name,
                        value: item.checked
                      }
                    })
                  ],
                  1
                ),
                _vm.isOther(item) && item.checked && !_vm.isReadOnly
                  ? _c(
                      "div",
                      { staticClass: "w-100" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        disabled: "",
                                        error: errors[0]
                                      },
                                      model: {
                                        value: item.other,
                                        callback: function($$v) {
                                          _vm.$set(item, "other", $$v)
                                        },
                                        expression: "item.other"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }